export function formatYearRange(yearStart, yearEnd) {
  if (yearStart && yearEnd) return `${yearStart}–${yearEnd}`;
  if (yearStart) return `${yearStart}+`;
  if (yearEnd) return `–${yearEnd}`;
  return null;
}

export const fmtMoney = (n) =>
  n === null || n === undefined || n === ""
    ? "—"
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(n);

/**
 * Map a watch-status string to Tailwind classes for the coloured pill.
 * Centralised so Inventory, WatchDetail, and Dashboard all colour the
 * same way.
 */
export function statusTone(s) {
  if (!s) return "bg-[#2B2214]/[0.14] text-[#3A2A10] border-[#8B6A1F]/45";
  const lower = s.toLowerCase();
  if (lower === "running" || lower === "overhauled" || lower.includes("runs"))
    return "bg-emerald-500/10 text-emerald-400 border-emerald-500/20";
  if (lower === "sold")
    return "bg-neutral-500/10 text-[#3A2A10] border-neutral-500/20";
  if (lower.includes("bad") || lower.includes("broken") || lower.includes("missing"))
    return "bg-rose-500/10 text-rose-400 border-rose-500/20";
  if (lower.includes("needs") || lower.includes("process") || lower.includes("slow"))
    return "bg-amber-500/10 text-amber-400 border-amber-500/20";
  if (lower.includes("for sale"))
    return "bg-[#D4AF37]/10 text-[#3A2A10] border-[#D4AF37]/20";
  return "bg-[#2B2214]/[0.14] text-[#0A0604] border-[#8B6A1F]/45";
}
